<template>
  <span class="Appkit4-icon icon-close-outline close-button"></span>
</template>

<style scoped lang="scss">
.close-button {
  padding: 20px;
  &:hover {
    cursor: pointer;
    background-color: var(--light-grey-2);
  }
}
</style>
